const queue = []

let pending = false

export function nextTick(callable) {

    queue.push(callable)

    if (!pending) {

        pending = true

        queueMicrotask(() => {

            const toRun = queue.slice()

            queue.length = 0
            pending = false

            for (const callback of toRun) {

                try {
                    callback()
                } catch (error) {
                    console.error('Error in nextTick callback:', error)
                }

            }

        })

    }

}
